module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAABKUlEQVQ4T63UsW6DMBAG4P9U2GFg7otUaiP1kLqkT9M1oVn7NO1SCVdqIvVFMjPADpWrs+LIOBhaikeO+/zbGBMWHrSwhx6olPoEcPfHSfbMvLI9Z1ApJZCAc8aKmffS6IJz0tnJD8xsVmbAf6azqElpQYl7O2etTo9JSQulO6cUMJTuCOA6kDpUOwhYANi6jVrrXRzHL13XvQO48dCvKIoe2rZ9IqKNVyvsHgoosBlaa9U0zWOWZVcearCqqr6TJHklInbAgpmf3WMzhWIK653D0/EJolIfS3bxp9gHSqkeCuCjruu11NM0fQNw7y/T3cfBy2EIPTWNYhdLdmcaQN2y+QBDR2r0+irLckNEfmMQG01oZ3dRrfU2z/Pd2C/6qwtWUEGmMHnnByDWlSZcBp/8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/middle_four.png
// module id = mCuC
// module chunks = 1